// chunkReloadGuard — recover gracefully from "Loading chunk X failed" errors
// that happen when a user has a stale index.html cached after a deploy and
// tries to lazy-load a chunk filename that no longer exists.
//
// Strategy: on the first matching error in this tab, force one full reload
// with a cache-bust query param. Only reload once per session so we never
// fall into an infinite refresh loop.

const RELOAD_FLAG = "__kl_chunk_reload_attempted__";

function isChunkLoadError(errOrEvt) {
  const msg = (
    errOrEvt?.message ||
    errOrEvt?.reason?.message ||
    errOrEvt?.reason ||
    errOrEvt ||
    ""
  ).toString();
  const name = errOrEvt?.name || errOrEvt?.reason?.name || "";
  return (
    name === "ChunkLoadError" ||
    /Loading chunk [\w-]+ failed/i.test(msg) ||
    /Loading CSS chunk [\w-]+ failed/i.test(msg) ||
    /failed to fetch dynamically imported module/i.test(msg) ||
    /Importing a module script failed/i.test(msg)
  );
}

function attemptReloadOnce() {
  try {
    if (sessionStorage.getItem(RELOAD_FLAG)) return false;
    sessionStorage.setItem(RELOAD_FLAG, Date.now().toString());
  } catch (_) {
    // sessionStorage may be unavailable (Safari private mode) — skip the
    // guard rather than risk an infinite loop.
    return false;
  }
  const u = new URL(window.location.href);
  u.searchParams.set("_klr", Date.now().toString().slice(-6));
  window.location.replace(u.toString());
  return true;
}

export function installChunkReloadGuard() {
  if (typeof window === "undefined") return;

  window.addEventListener("error", (evt) => {
    if (isChunkLoadError(evt) || isChunkLoadError(evt.error)) {
      if (attemptReloadOnce()) evt.preventDefault?.();
    }
  });

  window.addEventListener("unhandledrejection", (evt) => {
    if (isChunkLoadError(evt) || isChunkLoadError(evt.reason)) {
      if (attemptReloadOnce()) evt.preventDefault?.();
    }
  });
}

export { isChunkLoadError };
